// extracted by mini-css-extract-plugin
export default {"hamburger":"Hamburger_hamburger__fvJjf","burger":"Hamburger_burger__AII9s"};